import React from "react";
import { Input as AntInput } from "antd";
import { InputProps } from "antd/lib/input";

const Input: React.FC<InputProps> = props => {
	return <AntInput.Password {...props} />;
};
export default Input;
